import { render, staticRenderFns } from "./question-matrix-element.vue?vue&type=template&id=dc51d9a6&scoped=true"
import script from "./question-matrix-element.vue?vue&type=script&lang=js"
export * from "./question-matrix-element.vue?vue&type=script&lang=js"
import style0 from "./question-matrix-element.vue?vue&type=style&index=0&id=dc51d9a6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc51d9a6",
  null
  
)

export default component.exports